import { z } from 'zod';

export const offlineEventContentsSchema = z.object({
  id: z.string(),
  quantity: z.number(),
  price: z.number().optional(),
  brand: z.string().optional(),
  category: z.string().optional(),
});

export type OfflineEventContents = z.infer<typeof offlineEventContentsSchema>;
